/**
 * Fix for "modal.show is not a function" error
 * Polyfill for modal-opener component and close buttons
 */

(function() {
  // Wait for DOM to be ready
  function fixModalOpeners() {
    // Fix OPEN functionality - modal-opener elements
    const modalOpeners = document.querySelectorAll('modal-opener');
    
    modalOpeners.forEach(opener => {
      opener.addEventListener('click', function(e) {
        const modalId = this.getAttribute('data-modal');
        if (modalId) {
          const modal = document.querySelector(modalId);
          if (modal) {
            // If modal has a show method, use it
            if (typeof modal.show === 'function') {
              modal.show(this);
            } else {
              // Otherwise, open it manually
              modal.setAttribute('open', '');
              document.body.style.overflow = 'hidden';
            }
          }
        }
      });
    });
    
    // Fix CLOSE functionality - close buttons
    const closeButtons = document.querySelectorAll('.product-media-modal__toggle, .modal-close-button');
    
    closeButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        // Find the closest modal (parent)
        const modal = this.closest('product-modal') || this.closest('[id^="ProductModal"]');
        if (modal) {
          // If modal has a hide method, use it
          if (typeof modal.hide === 'function') {
            modal.hide();
          } else {
            // Otherwise, close it manually
            modal.removeAttribute('open');
            document.body.style.overflow = '';
          }
        }
      });
    });
    
    // Also close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        const openModals = document.querySelectorAll('product-modal[open]');
        openModals.forEach(modal => {
          if (typeof modal.hide === 'function') {
            modal.hide();
          } else {
            modal.removeAttribute('open');
            document.body.style.overflow = '';
          }
        });
      }
    });
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixModalOpeners);
  } else {
    fixModalOpeners();
  }
  
  // Re-run on Shopify section reload
  document.addEventListener('shopify:section:load', fixModalOpeners);
})();